import { type AxiosInstance } from 'axios'

export default (axios: AxiosInstance) => ({
  listAll() {
    return axios.get('/v1/questions/')
  },
  byId(id: number) {
    return axios.get(`/v1/questions/${id}/`)
  },
  listStandardMetricsWithCategories() {
    return axios.get('/v1/questions/standard-metrics-categories/')
  },
  listTopicMetrics() {
    return axios.get('/v1/questions/topics-metrics/')
  },
  listSections(params?: { sort_by_title?: boolean }) {
    return axios.get(`/v1/questions/sections/`, { params })
  },
  listMetric() {
    return axios.get(`/v1/questions/item-name-metrics/`)
  },
  getMetricData(filterQueryString: string) {
    return axios.get(`/v1/questions/metrics/?${filterQueryString}`)
  },
  listPublishedQuestions() {
    return axios.get('/v1/questions/item-name-questions/?sort_by_status=published')
  },
  listDraftQuestions() {
    return axios.get('/v1/questions/item-name-questions/?sort_by_status=draft')
  },
  getSections(id: number | string) {
    return axios.get(`/v1/questions/sections/${id}/`)
  },
  amoqThemeQuestionsCount(frameworks: string, year: number, theme: ThemeName) {
    return axios.get('/v1/questions/amoq-theme-count/', {
      params: {
        frameworks, // comma-separated framework IDs
        year, // reporting year
        theme, // 'environmental', 'social', or 'governance'
      },
    })
  },
  amoqAnswer(companyId: number, reportingYear: number, questionId: number) {
    return axios.get(`/v1/questions/amoq-answers/company/${companyId}/resporting-year/${reportingYear}/question/${questionId}`)
  },
  createAmoqAnswer(data: AmoqAnswer) {
    return axios.post('/v1/questions/amoq-answers/create-amoq-answer/', data)
  },
  updateAmoqAnswer(id: number, data: AmoqAnswer) {
    return axios.put(`/v1/questions/amoq-answers/update-amoq-answer/${id}/`, data)
  },
  multipleReportGenerate(query: string = '') {
    return axios.get(`/v1/questions/amoq-answers/multiple-report-generate/${query}`)
  },
  sections() {
    return axios.get('/v1/questions/sections/')
  },
})
